// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2Y5OP","col":"Table_col__SMXMk","fulfillmentStatus":"Table_fulfillmentStatus__1EwFb","emailCol":"Table_emailCol__3-Uvf"};